
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/terms-of-use",
      function () {
        return require("private-next-pages/[locale]/terms-of-use.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/terms-of-use"])
      });
    }
  